import React from 'react';
import { Checkbox } from '@trussworks/react-uswds';

export function USWDSCheckbox(props) {
  return <Checkbox {...props} />;
}
